export default __webpack_public_path__ + "static/media/punch.4f87dca0.png";